export default {
  // ========== Selectors ==========
  selectType: '-- Select {entity} type --',

  // ========== Reports ==========
  report: '{entity} report',
  download: 'Download',
  plansAndSubjectsReport: 'Plans and Subjects Report',
  plansAndEvaluationsReport: 'Plans and Evaluations Report',
  educationalTechnologyReport: 'Educational Technology Report',
  mandatoryBibliographyReport: 'Mandatory Bibliography Report',
  valuationReport: '{entity} Valuation Report',
  mattersReport: '{entity} Report',

  // ========== Validations and messages ==========
  needToChooseAtLeastOne: 'You need to choose at least 1 {entity}',
  cannotChooseMoreThan: 'Cannot choose more than {entity} {entity2}',
  cannotChooseMoreThan10: 'Cannot choose more than 10 {entity}',

  // ========== View actions ==========
  showHideAll: '{action} {entity}',
  goToAction: 'Go to...',

  // ========== Navigation ==========
  studyPlan: 'Study plan',
  curricularMesh: 'Curricular mesh',
  goToProfile: 'Go to profile',
  goToThe: 'Go to {entity}',
  goToStudyPlan: 'Go to study plan',
  goToCurricularMesh: 'Go to curricular mesh',

  // ========== Table fields ==========
  year: 'Year',
  curriculumNumber: 'Curriculum number',
  modality: 'Modality',
  programType: 'Program type',

  // ========== Report ==========
  entryValidity: 'Entry Validity',
  level: 'Level',
  shift: 'Shift',
  grantedTitle: 'Granted Title',
  duration: 'Duration',
  facultyArea: '{entity} Area',
  kf: 'KF',
  noData: 'No data to display',
  generatingExcel: 'Generating Excel...',
  pleaseWaitWhileGenerating: 'Please wait while the file is being generated.',
  downloadError: 'The file could not be downloaded.',
  error: 'Error',
  generationError: 'There was a problem generating the file.',

  // ========== Bulk selection ==========
  profilesSelected: '{count} profile(s) selected.',
  selectAllPrograms: 'Select all {count} programs?',
  allSelected: '{count} profiles selected in total.',
  clearSelection: 'Clear selection',

  // ========== Success messages ==========
  entityDeleted: '{entity} deleted.',
}
